import { isString } from '@axilon-apps/libs-shared-utils'
import { logger } from '@axilon-apps/libs-ui-core'

import type { Model } from '../../../../types'

import AuthenticationTokenService from './authentication-token-service'

const AUTHENTICATION_KEY = 'authentication'

class AuthenticationStorageService {
  public id: string | null = null
  public accessToken: AuthenticationTokenService | null = null
  public refreshToken: AuthenticationTokenService | null = null
  private token: Model.Token | null = null

  public initialize() {
    this.reset()
    this.load()
    if (!this.token) {
      return
    }

    try {
      const { id, accessToken, refreshToken } = this.token

      this.id = id
      this.accessToken = new AuthenticationTokenService(accessToken)
      this.refreshToken = new AuthenticationTokenService(refreshToken)
    } catch (error) {
      logger.error('Failed to initialize authentication token', { error, token: this.token })
      this.clear()
      this.reset()
    }
  }

  public get() {
    return this.token
  }

  public save(token: Model.Token) {
    localStorage.setItem(AUTHENTICATION_KEY, JSON.stringify(token))
  }

  public clear() {
    localStorage.removeItem(AUTHENTICATION_KEY)
    this.reset()
  }

  private load() {
    const authData: Model.Token | null = JSON.parse(
      localStorage.getItem(AUTHENTICATION_KEY) as string
    )

    if (
      !authData ||
      !isString(authData.accessToken) ||
      !isString(authData.refreshToken) ||
      !isString(authData.id)
    ) {
      return
    }

    this.token = authData
  }

  private reset() {
    this.id = null
    this.accessToken = null
    this.refreshToken = null
    this.token = null
  }
}

export default AuthenticationStorageService
